<template>
  <img
    :src="modoPR == 'R' ? imgReceber : imgPagar"
    :style="{ width: tamanho }"
  />
</template>

<style lang="scss" scoped></style>

<script>
export default {
  name: "Loading",
  data() {
    return {
      imgReceber: "media/logos/Pulse-1s-200px.gif",
      imgPagar: "media/logos/Pulse-1s-200pxR.gif"
    };
  },
  props: ["modoPR", "tamanho"]
};
</script>
